<template>
  <BlurWrapper class="blur-upgrade-wrapper" :blur="blur">
    <slot />
    <div v-if="blur" slot="overlay">
      <div class="text">
        {{ text }}
      </div>
      <div class="hint">
        {{ hint }}
      </div>
      <a class="shizen-upgrade-link" href="https://shizen.io/demo" target="_blank">
        {{ $t('message.GET_FULL_SHIZEN') }}
      </a>
    </div>
  </BlurWrapper>
</template>

<script>
/**
 * Display content of a slot into an blur-overlay-able component
 */

// Components
import BlurWrapper from '@/components/blur-wrapper.vue';


export default {
  name: 'BlurUpgradeWrapper',

  components: {
    BlurWrapper,
  },

  props: {
    blur: Boolean,
    text: {
      type: String,
      default: '',
    },
    hint: {
      type: String,
      default: '',
    },
  },

  computed: {
    blurClasses() {
      return {
        blurred: this.blur,
      };
    },
  },
};
</script>

<style lang="scss">
.blur-upgrade-wrapper {
  .blur-overlay {
    text-align: center;
    font-weight: 550;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background: rgba(255, 255, 255, 0.5);
    box-shadow: 0px 0px 15px rgba(255, 255, 255, 0.7);

    div {

      &.hint, &.text {
        text-shadow: 0px 0px 1px white;
      }

      &.hint {
        font-weight: initial;
        margin-top: 0.5em;
      }
    }
  }
}
</style>
